import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { COMPANY_STATUS_ENUM } from "interfaces";

export class PendingActionsCompanyList extends ListStoreConstructor<any> {
  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        const paramsWithSort = {
          ...params,
          statuses: COMPANY_STATUS_ENUM.DRAFT,
        };
        return services.getCompanyList(paramsWithSort).then((response) => ({
          content: response.content || [],
          size: response.size || 0,
          totalPages: response.totalPages || 0,
          totalElements: response.totalElements || 0,
        }));
      },
      {
        sorters: {
          statusDate: "asc",
        },
        pollingInterval: 10000,
      }
    );
  }
}
